import { render, staticRenderFns } from "./OrderScanReportInfoCard.vue?vue&type=template&id=6a11841e&"
import script from "./OrderScanReportInfoCard.vue?vue&type=script&lang=ts&"
export * from "./OrderScanReportInfoCard.vue?vue&type=script&lang=ts&"
import style1 from "./OrderScanReportInfoCard.vue?vue&type=style&index=1&id=6a11841e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports